<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-50">
    <div class="max-w-md w-full space-y-8">
      <div class="text-center">
        <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
        <h2 class="mt-6 text-2xl font-bold text-gray-900">
          {{ message }}
        </h2>
        <p class="mt-2 text-gray-600">
          {{ subMessage }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useAuthStore } from '../stores/auth'

const router = useRouter()
const route = useRoute()
const authStore = useAuthStore()

const message = ref('Confirming your email...')
const subMessage = ref('Please wait while we process your confirmation.')

onMounted(async () => {
  try {
    // Supabase will handle the email confirmation automatically
    // The URL will contain the necessary tokens as hash parameters
    
    // Wait a moment for Supabase to process the confirmation
    await new Promise(resolve => setTimeout(resolve, 2000))
    
    // Try to initialize auth to get the session
    await authStore.initialize()
    
    if (authStore.isAuthenticated) {
      message.value = 'Email confirmed successfully!'
      subMessage.value = 'Redirecting to dashboard...'
      
      setTimeout(() => {
        router.push('/')
      }, 1500)
    } else {
      message.value = 'Email confirmed!'
      subMessage.value = 'Please log in to continue.'
      
      setTimeout(() => {
        router.push('/login')
      }, 2000)
    }
  } catch (error) {
    console.error('Auth callback error:', error)
    message.value = 'Something went wrong'
    subMessage.value = 'Please try logging in.'
    
    setTimeout(() => {
      router.push('/login')
    }, 2000)
  }
})
</script>